import Expandable from '../expandable/expandable.js';

const pluginName = 'expandable';
const selector = 'data-expand';
const elements = '[data-expand]';
const height = 58;

export default {
    init() {
        $.fn[pluginName] = function() {
            return this.each((i, el) => {

                if ($(el).data('active') === true) {
                    return;
                }

                if (!$(el).data('expand-media-query') || window.matchMedia($(el).data('expand-media-query')).matches) {
                    let expandable = new Expandable(el, $(el).attr(selector) || height);
                    expandable.init();
                }
            });
        };

        $(elements)[pluginName]();

        $(document).on('enhance:ajaxload', () => {
            $(elements)[pluginName]();
        });
    }
};
